export interface VideoItem {
  title: string;
  url: string;
  category?: string;
}

export const videos: VideoItem[] = [
  // INSTALL / SETUP
  { title: "Okai UV DTF Film Install", url: "https://youtu.be/FKgu85dm_9o", category: "Install" },
  { title: "Okai UV DTF Install", url: "https://youtu.be/M57NLbsXy2M", category: "Install" },
  { title: "Okai 24 Inch Mini Install", url: "https://youtu.be/ArTzVF_dPAw", category: "Install" },
  { title: "Okai 13 inch Printer Install", url: "https://youtu.be/V-UFalbyndE", category: "Install" },
  { title: "Maintop Install", url: "https://youtu.be/MubctB4q7NQ", category: "Software" },
  { title: "Okai Printer Install", url: "https://youtu.be/pgrUDfcAXSk", category: "Install" },
  { title: "Okai Printer Install (Alt)", url: "https://youtu.be/qJ2WnfzooTQ", category: "Install" },

  // TROUBLESHOOTING / PRINT QUALITY
  { title: "DTF Printhead Alignment", url: "https://youtu.be/BYMYcPBb-7c", category: "Troubleshooting" },
  { title: "How To Change Print Quality In PrintXP", url: "https://youtu.be/_cxweBnT4kY", category: "Software" },
  { title: "Mastering White Underbase Choke", url: "https://youtu.be/cUGVJx8CgZQ", category: "Troubleshooting" },
  { title: "How To Setup Margins in Print XP", url: "https://youtu.be/I4hhDr7rfLE", category: "Software" },
  { title: "Print XP Hosonsoft Secrets", url: "https://youtu.be/1GgCqH5xc48", category: "Software" },

  // MAINTENANCE
  { title: "How To Save Printhead With Purple Hammer", url: "https://youtu.be/HUqJTWLgyQM", category: "Maintenance" },
  { title: "DTF Print Head Cleaning With Foam Swabs", url: "https://youtu.be/5e3Iv2zyXHU", category: "Maintenance" },
  { title: "DTF Complete Ink Flush When Changing Brands", url: "https://youtu.be/yOkBc56lO_w", category: "Maintenance" },
  { title: "How To Clean Capping Stations", url: "https://youtu.be/r-uUonjbLAM", category: "Maintenance" },
  { title: "How To Waterfall Printhead", url: "https://youtu.be/2_tsCiYukJY", category: "Maintenance" },
  { title: "Replacing Rolls And Tension", url: "https://youtu.be/oRkonOTfBlU", category: "Hardware" },

  // BEGINNER / OVERVIEW
  { title: "DTF 101: Beginner's Guide to Direct to Film Printing", url: "https://youtu.be/tnwqGe2Mi4A", category: "Beginner" },
  { title: "DTF Printing Beginner's Guide: Printing, Pressing and More", url: "https://youtu.be/Cs95HjxydDE", category: "Beginner" },
  { title: "Beginner's Guide to Direct-to-Film (DTF) Transfer", url: "https://youtu.be/stDJ2NQfw8g", category: "Beginner" },

  // PRESSING
  { title: "How To Properly Press DTF Transfers From Pro World", url: "https://youtu.be/Dt-DlJSfgWM", category: "Pressing" },
  { title: "The Best Methods for Pressing DTF Films", url: "https://youtu.be/qJAtLxD0jfY", category: "Pressing" },
  { title: "How to Press DTF Transfers with a Cricut EasyPress", url: "https://youtu.be/K2gbfTEutWw", category: "Pressing" },
  { title: "Ninja Transfers x S&S – DTF Transfers Pressing Instructions", url: "https://youtu.be/-EUi8KrsRYQ", category: "Pressing" },
  { title: "Zippers, Seams & Buttons Oh My! | DTF How To", url: "https://youtu.be/UkBXC_ibwOU", category: "Pressing" },

  // POWDER / CURING
  { title: "How to Cure DTF Powder with Heat Press", url: "https://youtu.be/ZvG-y8eJaN4", category: "Powder" },
  { title: "4 Ways To Dry Your DTF Transfers", url: "https://youtu.be/KKoREN8OPoo", category: "Powder" },
  { title: "How To Cure DTF Film With The Gallery DTF Small Curing Oven", url: "https://youtu.be/ATdbzZqWPq8", category: "Powder" },
  { title: "Dialing In DTF Curing: Powder Shaker & Oven Setup, Settings", url: "https://youtu.be/-ag_38oxWqg", category: "Powder" },
  { title: "Best Way to Cure DTF Prints at Home", url: "https://youtu.be/2ek4g-HPpd0", category: "Powder" },
  { title: "The DTF Curing Process | GPI Lab", url: "https://youtu.be/qKjCat-L5N8", category: "Powder" },
  { title: "DTF Basics | An Experts Guide to Curing", url: "https://youtu.be/pvn-nKi7TBw", category: "Powder" },
  { title: "How to Powder and Cure a DTF Print", url: "https://youtu.be/yX3sXLxvQcg", category: "Powder" },

  // EXTRA MAINTENANCE
  { title: "How to UNCLOG DTF Print Head (Step-by-Step)", url: "https://youtu.be/jR8Odw0Yu34", category: "Maintenance" },
  { title: "How to Clean DTF Print Head", url: "https://youtu.be/PB4YjA2ogvM", category: "Maintenance" },
  { title: "How to Clean i3200 Printheads on Your DTF Printer", url: "https://youtu.be/AlRYvPca_H0", category: "Maintenance" },
  { title: "How to Properly Clean Your DTF Commercial Printer", url: "https://youtu.be/dGaqKI6Ii-A", category: "Maintenance" },
  { title: "Cleaning & Flushing your DTF Print Head", url: "https://youtu.be/PsJeirO7mNU", category: "Maintenance" },

  // ARTWORK / PHOTOSHOP
  { title: "Adding white layer in Photoshop for DTF", url: "https://youtu.be/28Tw2eSfymU", category: "Artwork" },
  { title: "How to Add Spot Color White Underbase for DTF Printing in Photoshop", url: "https://youtu.be/dpAQ1cpdcIA", category: "Artwork" },
  { title: "Prepping Photoshop Art for DTF Printing | Deep Dive With Colin", url: "https://youtu.be/HPIulXxtfFI", category: "Artwork" },
];